import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
    FeeCalculationState,
    packageFees,
    isIncreasePricingTier,
    totalFee
} from './fee-calculation.selector';

@Injectable()
export class FeeCalculationFacade {
    packagePrices$ = this.store.pipe(select(packageFees));
    isIncreasePricingTier$ = this.store.pipe(select(isIncreasePricingTier));
    totalFee$ = this.store.pipe(select(totalFee));
    constructor(private store: Store<FeeCalculationState>) {}
}
